var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      pad: "0",
      title: _vm.$t("label_essweb_ClaimRecord_form_viewTitle"),
      widthClass: "max-1000",
      backgroundClass: "transparent",
    },
    scopedSlots: _vm._u([
      {
        key: "nav-actions",
        fn: function () {
          return [
            _c(
              "v-btn",
              {
                staticClass: "primary mr-4",
                attrs: { rounded: "" },
                on: {
                  click: function ($event) {
                    _vm.showEditPaymentStatus = true
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("label_essweb_ClaimRecord_form_changeStatusLabel")
                  )
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _vm.ClaimRecordData
              ? _c("ApprovalTriger", {
                  attrs: {
                    "bg-color": _vm.ClaimRecordData.approval_bg_color,
                    "slide-color": _vm.ClaimRecordData.approval_tint_color,
                  },
                  on: {
                    triger: function ($event) {
                      return _vm.$toPage(
                        "/admin/claim-record/detail/" +
                          _vm.$route.params.params +
                          "/approval-detail/" +
                          _vm.$route.params.params
                      )
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "time",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getDateTime(
                                    _vm.ClaimRecordData.operate_utc_datetime,
                                    "YYYY/MM/DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "status",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.ClaimRecordData.status_detail
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    388985468
                  ),
                })
              : _vm._e(),
            _c("Taber", {
              attrs: {
                curTab: _vm.curTab,
                items: _vm.taber,
                special: "",
                backgroundColor: "transparent",
                contentBackground: "mrc-grey pa-0",
              },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "Section",
                        { attrs: { isStart: "" } },
                        [
                          _c(
                            "v-form",
                            { ref: "form", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_swiftNumberLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                        model: {
                                          value:
                                            _vm.ClaimRecordData.swift_number,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ClaimRecordData,
                                              "swift_number",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ClaimRecordData.swift_number",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getDateTime(
                                            _vm.ClaimRecordData
                                              .submission_utc_datetime,
                                            "YYYY/MM/DD HH:mm"
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_createdOnLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimRecordData.claim_type_name
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_claimTypeLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("AutoComplete", {
                                        attrs: {
                                          label:
                                            "label_essweb_leaveApplication_form_applicantLabel",
                                          readonly: "",
                                          items: _vm.users,
                                          chips: "",
                                          avatar: "",
                                          "small-chips": "",
                                          "two-line": "",
                                          "item-value": "uuid",
                                          "item-text": "preferred_name",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection.avatar",
                                            fn: function (ref) {
                                              var data = ref.data
                                              return [
                                                _c("StaffAvatar", {
                                                  attrs: {
                                                    src: data.item.staff_avatar,
                                                    left: "",
                                                    small: "",
                                                    isTemp: data.item.is_temp,
                                                    staff_name:
                                                      data.item.preferred_name,
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                        model: {
                                          value: _vm.user,
                                          callback: function ($$v) {
                                            _vm.user = $$v
                                          },
                                          expression: "user",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Section",
                        [
                          _c(
                            "v-form",
                            { ref: "form", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimRecordData
                                              .payment_status_detail
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_paymentStatusLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimRecordData
                                              .payment_method_detail
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_paymentMethodsLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimRecordData
                                              .payment_reference
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_paymentReferenceLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Section",
                        [
                          _c(
                            "v-form",
                            { ref: "form", attrs: { "lazy-validation": "" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimRecordData.claim_form_name
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_claimFormTitleLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          filled: false,
                                          readonly: true,
                                          value: _vm.$getCommonLangValue(
                                            _vm.ClaimRecordData
                                              .claim_form_description
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_claimFormDescriptionLabel"
                                          ),
                                          isNotRequire: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-card",
                        {
                          staticClass:
                            "pa-0  elevation-0 primary lighten-4 rounded-lg",
                        },
                        [
                          _c("v-card-text", [
                            _c(
                              "div",
                              {
                                staticClass: "text-left text-h6  text--primary",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_ClaimRecord_form_claimTotalAmountLabel"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-right text-h5  text--primary",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currency_code) +
                                    " " +
                                    _vm._s(
                                      _vm.$get_thousand_num(
                                        parseFloat(
                                          Number(
                                            _vm.claim_total_amount
                                          ).toFixed(4)
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Section",
                        [
                          _c("Tabler", {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.desserts,
                              border: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.type",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_item_type_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.name",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.claim_item_name
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.actual_amount",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    Number(item.is_show_actual_amount)
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.actual_currency_code
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.$get_thousand_num(
                                                  parseFloat(
                                                    Number(
                                                      item.actual_amount
                                                    ).toFixed(4)
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.claim_amount",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.claim_currency_code) +
                                        " " +
                                        _vm._s(
                                          _vm.$get_thousand_num(
                                            parseFloat(
                                              Number(item.claim_amount).toFixed(
                                                4
                                              )
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.approval_amount",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.currency_code) +
                                        " " +
                                        _vm._s(
                                          _vm.$get_thousand_num(
                                            parseFloat(
                                              Number(
                                                item.approved_amount
                                              ).toFixed(4)
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.action",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toViewItem(item.uuid)
                                          },
                                        },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "currentColor",
                                            iconClass: "viewDetail",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("editPaymentStatus", {
              attrs: {
                show: _vm.showEditPaymentStatus,
                method: _vm.ClaimRecordData.payment_method,
                status: _vm.ClaimRecordData.payment_status_uuid,
                reference: _vm.ClaimRecordData.payment_reference,
              },
              on: {
                close: function ($event) {
                  _vm.showEditPaymentStatus = false
                },
                save: _vm.onSave,
              },
            }),
            _c("viewClaimItem", {
              attrs: { show: _vm.showClaimItem, curUuid: _vm.curUuid },
              on: {
                close: function ($event) {
                  _vm.showClaimItem = false
                  _vm.curUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }